/* @flow weak */
import cx from 'classnames';
import React from 'react';

import Button from 'components/Button.jsx';
import Columns2 from 'components/Columns2.jsx';
import CurrentUser from 'auth/CurrentUser';
import DatePickerInput from 'components/DatePickerInput.jsx';
import Field from 'components/Field.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Groups from 'collections/Groups';
import Label from 'components/Label.jsx';
import Legend from 'components/Legend.jsx';
import MessageActions from 'groups/actions/MessageActions';
import Select from 'components/Select.jsx';
import SetUserEmailModal from 'settings/components/SetUserEmailModal.jsx';
import { mountModal } from 'lib/modal';

import SettingsContainer from './SettingsContainer.jsx';

import './styles/PrintSettingSection.scss';

const ALL_CLASSES_OPTION = { label: 'All classes', value: '_all' };

const PrintAnnouncements = React.createClass({
  propTypes: {
    groups: React.PropTypes.instanceOf(Groups).isRequired,
  },

  getInitialState() {
    const startDate = this.sixMonthsAgo();
    const endDate = new Date();

    return {
      group: ALL_CLASSES_OPTION,
      startDate,
      endDate,
      groupOptions: this.getFormattedGroupSelectOptions(),
    };
  },

  getFormattedGroupSelectOptions() {
    return [ALL_CLASSES_OPTION].concat(
      this.props.groups.map((group) => {
        return { label: group.getName(), value: group.id };
      })
    );
  },

  setSelectedGroup(value) {
    const group = this.state.groupOptions.find(option => option.value === value);
    this.setState({ group });
  },

  canSubmit() {
    return (
      this.state.group !== null &&
      this.state.startDate !== null &&
      this.state.endDate !== null &&
      this.state.startDate < this.state.endDate
    );
  },

  handleEndDateChange(date) {
    this.setState({ endDate: date });
  },

  handleStartDateChange(date) {
    this.setState({ startDate: date });
  },

  printAnnouncements() {
    if (!CurrentUser.hasEmail()) {
      return mountModal(<SetUserEmailModal onSave={this.printAnnouncements} />, this);
    }

    let groupIds;

    // if selected group is all class pass an empty array.
    const allGroups = ALL_CLASSES_OPTION.value;
    if (this.state.group.value === allGroups) {
      groupIds = [];
    } else {
      groupIds = [this.state.group.value];
    }

    MessageActions.export(groupIds, this.state.startDate, this.state.endDate);
  },

  sixMonthsAgo() {
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
    return sixMonthsAgo;
  },

  render() {
    const today = new Date();

    return (
      <div className="PrintAnnouncements PrintSettingSection">
        <Fieldset>
          <Legend>
            Announcements
            <p>
              Export a PDF of all the announcements you’ve sent to participants in a class.
            </p>
          </Legend>

          <SettingsContainer>
            <Field>
              <Columns2 gutter="small">
                <div>
                  <Label>Class</Label>
                  <Select
                    className="PrintSettingSection-groupSelector"
                    options={this.state.groupOptions}
                    value={this.state.group.value}
                    onChange={this.setSelectedGroup}
                  />
                </div>

                <div>
                  <Columns2 gutter="small">
                    <div>
                      <Label>Start date</Label>
                      <DatePickerInput
                        className={cx('PrintSettingSection-dateSelector control input', {
                          error: this.state.startDate > today,
                        })}
                        ref="startdate"
                        value={this.state.startDate}
                        max={today}
                        onChange={this.handleStartDateChange}
                      />
                    </div>

                    <div>
                      <Label>End date</Label>
                      <DatePickerInput
                        className={cx('PrintSettingSection-dateSelector control input', {
                          error: this.state.startDate >= this.state.endDate,
                        })}
                        ref="endDate"
                        value={this.state.endDate}
                        min={this.state.startDate}
                        max={today}
                        onChange={this.handleEndDateChange}
                      />
                    </div>
                  </Columns2>
                </div>
              </Columns2>
            </Field>
          </SettingsContainer>

          <Button size="small" disabled={!this.canSubmit()} onClick={this.printAnnouncements}>
            Export
          </Button>
        </Fieldset>
      </div>
    );
  },
});

export default PrintAnnouncements;



// WEBPACK FOOTER //
// ./src/settings/components/PrintAnnouncements.jsx